import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { projects } from '../data/site';
import { Reveal } from './Reveal';
const featured = projects[1];
const others = projects.filter(project => project !== featured);
export function Projects() {
  return <section id="projets" className="border-t border-line bg-chalk py-24 lg:py-32" data-id="element-109" data-mp="ptf6p8u24lqx">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-110" data-mp="13l3hn8skl46b">
        <Reveal data-id="element-111" data-mp="13jio9mhzrra1">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-112" data-mp="13n6hekjiybo8">
            <div data-id="element-113" data-mp="yod2cnolacly">
              <p className="text-[11px] uppercase tracking-label text-graphite" data-id="element-114" data-mp="1djj7z9jrw9er">Projets</p>
              <h2 className="mt-5 max-w-xl font-display text-4xl leading-[1.05] tracking-tight lg:text-5xl" data-id="element-115" data-mp="1dh6rz1xks94c">
                Réalisation de vos projets sur-mesure
              </h2>
            </div>
            <Link to="/projets" className="group inline-flex shrink-0 items-center gap-3 border-b border-ink pb-1 text-[11px] uppercase tracking-label" data-id="element-116" data-mp="3fcqx1ap6u5du">
              Tous les projets
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-117" data-mp="21d4h6gike49m" />
            </Link>
          </div>
        </Reveal>

        <Reveal delay={0.06} className="mt-14" data-id="element-118" data-mp="2b3fjxzqii7ex">
          <Link to="/projets" className="group grid gap-8 lg:grid-cols-12 lg:gap-10" data-id="element-119" data-mp="2b47gpdvuib6s">
            <figure className="overflow-hidden lg:col-span-8" data-id="element-120" data-mp="2g3brua2byizr">
              <img src={featured.image} alt={`${featured.title} — ${featured.description}`} className="h-[42vh] w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-[1.02] sm:h-[58vh]" data-id="element-121" data-mp="2l1ll2f4hv9iq" />
            </figure>
            <div className="flex flex-col lg:col-span-4" data-id="element-122" data-mp="up7an6ur5ul8">
              <p className="text-[11px] uppercase tracking-label text-clay" data-id="element-123" data-mp="uqqrozo8g9o2">{featured.category}</p>
              <h3 className="mt-4 font-display text-3xl leading-tight lg:text-4xl" data-id="element-124" data-mp="zosjc8zq5hb5">{featured.title}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-graphite" data-id="element-125" data-mp="22zptu5xprf5u">{featured.description}</p>
              <p className="mt-auto pt-8 text-[11px] uppercase tracking-label text-graphite" data-id="element-126" data-mp="1y1xuwryniss5">{featured.year}</p>
            </div>
          </Link>
        </Reveal>

        <ul className="mt-16 grid gap-10 sm:grid-cols-3" data-id="element-127" data-mp="270i5f5u25w5a">
          {others.map((project, index) => <Reveal key={project.title} delay={0.04 * index} className="h-full" data-id="element-128" data-mp="2lx0iyxpmss7k" data-mpi={index}>
              <li className="flex h-full flex-col" data-id="element-129" data-mp="2gzh7u6o8cvju">
                <Link to="/projets" className="group flex h-full flex-col" data-id="element-130" data-mp="2gypcmwyjozu3">
                  <figure className="overflow-hidden" data-id="element-131" data-mp="2up2jevzpa8hu">
                    <img src={project.image} alt={`${project.title} — ${project.description}`} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-[1.03]" data-id="element-132" data-mp="2qp0qbb816ne6" />
                  </figure>
                  <p className="mt-5 text-[11px] uppercase tracking-label text-clay" data-id="element-133" data-mp="3jaz05w3t50gm">{project.category}</p>
                  <h3 className="mt-3 font-display text-2xl leading-tight" data-id="element-134" data-mp="3o9adwhx83v44">{project.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-graphite" data-id="element-135" data-mp="39c17cgzcmkrt">{project.description}</p>
                  <span className="mt-auto pt-6 text-[11px] uppercase tracking-label text-graphite" data-id="element-136" data-mp="3eb4dy5uz8z1w">
                    {project.year}
                  </span>
                </Link>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}